import { PillStatus } from 'legacy-modules/styles';
import { Translate } from 'next-translate';
import React from 'react';

export const CellGenerator = (value, t: Translate) => {
  const transformLabels = [
    'in',
    'out',
    'cash',
    'bank',
    'APEC',
    'visa',
    'passport',
    'insurance',
  ];
  const bluePills = ['bank'];
  const greenPills = ['cash'];

  if (typeof value === 'string') {
    // generate label

    const isTransformed = transformLabels.find((label) => label === value);
    const isBluePill = bluePills.find((label) => label === value);
    const isGreenPill = greenPills.find((label) => label === value);

    const label = isTransformed ? t(`common:${value}`) : value;

    if (isBluePill) {
      return <PillStatus status="blue">{label}</PillStatus>;
    }

    if (isGreenPill) {
      return <PillStatus status="green">{label}</PillStatus>;
    }

    if (isTransformed) {
      return <>{label}</>;
    }

    // const dateRegExp =
    //   /^\d{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/;
    // if (value.match(dateRegExp)) {
    //   return <>{format(new Date(value), 'dd-MM-yyyy')}</>;
    // }

    return undefined;
  }

  return undefined;
};
